<style >
#menu{
  background: #fff;
}
.relative {
    position: relative;
}
.absolute {
    position: absolute;
}
.hidden {
    /* The menu is hidden at first */
    display: none;
}
#menu{
  z-index: 999;
  flex-direction: column;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 20px rgba(64, 64, 64, 0.15);
}
.menu-list {
  margin: 0;
  display: block;
  width: 100%;
  padding: 0px;
}
.menu-list + .menu-list {
  border-top: 1px solid #ddd;
}
.menu-sub-list {
  display: none;
  padding: 0px;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 10px 20px rgba(64, 64, 64, 0.15);
  position: absolute;
  left: 100%;
  right: 0;
  z-index: 9999;
  width: 100%;
  top: 0;
  flex-direction: column;
}
.menu-sub-list:hover {
  display: flex;
}
.menu-item {
  position: relative;
  list-style: none;
}
.menu-button {
  font: inherit;
  border: 0;
  padding: 5px 5px;
  padding-right: 36px;
  width: 100%;
  text-align: left;
  display: flex;
  align-items: center;
  position: relative;
  background-color: #fff;
}
.menu-button:hover {
  background-color: #f1f3f7;
}
.menu-button:hover + .menu-sub-list {
  display: flex;
}
.menu-button:hover svg {
  stroke: #3a3c42;
}
.menu-button .bx{
  flex-shrink: 0;
  font-size:20px;
  margin-right: 10px;
  color: #898c94;
}
.menu-button .mdi-menu-right {
  margin-right: 0;
  position: absolute;
  right: 8px;
}
.menu-button .delete {
  color: #d92027;
}
.menu-button--delete:hover svg:first-of-type {
  stroke: #d92027;
}
.menu-button--orange svg:first-of-type {
  stroke: #dc9960;
}
.menu-button--green svg:first-of-type {
  stroke: #1eb8b1;
}
.menu-button--purple svg:first-of-type {
  stroke: #657cc4;
}
.menu-button--black svg:first-of-type {
  stroke: #3a3c42;
}
.menu-button--checked svg:nth-of-type(2) {
  stroke: #657cc4;
}
.dropdown-menu{
  border: solid 2px #dedede;
}
</style> 
<script>
import CreateSetup from './setup'
import tableMixin from '@/helpers/mixins/table' 
import contextmenu from '@/helpers/mixins/contextmenu' 
import Table from '@/components/table' 
import Transaction from './transaction'
import TechDetay from '../modals/tech_detail'

export default {
  name: 'SetupList',
  props:[
    "data"
  ],
  data() {
    return {
        url:'',
        techDetail:{},
        title:'',
        buttons:[
            { title:"İşleme Al", icon:'check', func:this.islemeAl, visible: [1]},
            { title:"Arıza Detay", icon:'check', func:this.arizaDetay, visible: [3]},
            { title:"Düzenle",icon:'edit', func:this.edit, visible: [1,2,3,4]  },
            { title:"Sil",icon:'trash delete', func:this.destroy, visible: [1,2,3,4]  },
        ],  
        columns: [
          {
            label: 'Randevu Tarihi',
            field: "date_format",
            sortable: false,
          }, 
          {
            label: 'İsim Soyisim',
            field: "fullname",
            filterOptions: {
              enabled: true,
              filterDropdownItems: [],
            },
          },
          {
            label: 'Cep Telefonu',
            field: this.phonenumber,
            html: true,
            sortable: false,
          },
          {
            label: 'Whatsapp',
            field: this.whatsapp,
            html: true,
            sortable: false,
          },
          {
            label: 'Atanan',
            field: 'assigned_name',
            sortable: false,
          }, 
          {
            label: 'İl',
            field: "district_name",
            sortable: false,
          }, 
          {
            label: 'Bölge',
            field:  "quarter_name",
            sortable: false,
          },
          {
            label: 'Adres',
            field:  "address",
            sortable: false,
          }, 
          {
            label: 'Durum',
            field: this.status,
            html: true,
            sortable: false,
          },
        ],
        list: {},
        transactionData:{},
      }
    },
    mixins: [ contextmenu,tableMixin ],
    components: {
        CreateSetup,
        Table,
        Transaction,
        TechDetay
    },
    watch:{
        data(props){
                this.url = props.url
                this.title = props.fullname
                this.itemLoading = false
                this.updateParams({columnFilters:{subscription_id:props.subscription_id}})

            }
    },
    methods: {
        updateParams(newProps) {
            this.serverParams = { ...this.serverParams, ...newProps }
        },
        onPageChange(params) {
            this.updateParams({ page: params.currentPage })
            this.loadItems()
        },
        onPerPageChange(params) {
            this.updateParams({ perPage: params.currentPerPage })
            this.loadItems()
        },
        onSortChange(params) {
            this.updateParams({
                sort: params,
            })
            this.loadItems()
        },
        onColumnFilter(params) {
            this.updateParams(params)
            this.loadItems()
        },
        loadItems() {
            if(this.url == '') return
            this.getFromServer(this.serverParams).then(response => {
                this.totalRecords = response.totalRecords
                this.pageLength = response.pageLength
                this.currentPage = response.currentPage
                this.rows = response.rows
            })
        },
        getFromServer() {
            return new Promise((resolve, reject) => {
                this.$http.post(this.url, this.serverParams)
                .then(res => {
                    resolve({
                        rows: res.data.data,
                        totalRecords: res.data.total,
                        pageLength: res.data.last_page,
                        currentPage: res.data.current_page,
                    })
                })
                .catch(error => {
                    reject(error)
                })
            })
        },
        onSearch(params) {
            this.updateParams(params)
                this.loadItems()
            },
        close(){
            this.$parent.$bvModal.hide('setup_list')
        },
        status(obj){
            return `<span class="badge font-size-11 bg-${obj.classname}">${obj.status_name}</span>`
        },
        phonenumber(obj){
            const url =   obj.phonenumber2;
            return `<a href=tel:'${url}'  >${obj.phonenumber2}</a>`
        },
        whatsapp(obj){
            const url =  "https://wa.me/" + obj.phonenumber2;
            return `<a target="_blank" href='${url}'  >${obj.phonenumber2}</a>`
        },
        
        edit(props){
          // const props  = this.getCurrentClient()
          this.data = { type:props.type_id , update: true, ...props}
          this.$parent.$bvModal.show('setup')
        },
        arizaDetay(props){
            this.techDetail = props
            this.$parent.$bvModal.show('tech_detail')
        },
        islemeAl(props){
            this.transactionData = { subs_id:props.subscription_id, id:props.id}
            this.$parent.$bvModal.show('transaction')
        },
    },
};
</script>

<template>
  <b-modal id="setup_list" size="lg" :title="title"  no-close-on-backdrop hide-footer>
    <CreateSetup :data="data" />
    <Transaction :transactionData="transactionData" />
    <TechDetay :data="techDetail" />
    <Table 
      :url="url" 
      :columns="columns"
    >
    <template v-slot:prop-slot="{ row }">
       <ul class="list-inline font-size-20 contact-links mb-0">
        <li class="list-inline">
          <b-dropdown
            class="ms-2"
            toggle-class="text-muted font-size-16 p-0"
            toggle-tag="a"
            variant="white"
            menu-class="dropdown-menu-start"
            right
          >
              <template #button-content>
                <i class="mdi mdi-dots-horizontal"></i>
              </template>
              <template   
              v-for="(button,i) in buttons" >
              <b-dropdown-item 
                :key="i" 
                v-if="button.visible.includes(row.type_id)"
                @click="button.func(row)">
                <i class="bx" :class="`bx-${button.icon}`"></i> {{ button.title }}
              </b-dropdown-item>
              </template>
          </b-dropdown>
        </li>
      </ul>
    </template>
    </Table>
</b-modal>
</template>